import { useState, useEffect } from 'react';

export default function CelebrityImage({ imageUrl, blur, revealed, celebrityName }) {
  const [loaded,  setLoaded]  = useState(false);
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setLoaded(false);
    setErrored(false);
  }, [imageUrl]);

  const isClearbit = imageUrl?.includes('logo.clearbit.com');

  // Fallback — ui-avatars always works, no CORS issues
  const fallbackUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(celebrityName || 'ClueCue')}&size=400&background=6366f1&color=fff&bold=true&format=png`;

  const src = errored ? fallbackUrl : (imageUrl || fallbackUrl);

  return (
    <div style={styles.wrapper}>
      <div style={styles.badge}>
        {revealed ? '✅ Revealed' : `🔍 Blur: ${blur}px`}
      </div>

      <div style={{
        ...styles.imageContainer,
        background: isClearbit ? '#ffffff' : '#1a1a2e',
      }}>
        {!loaded && <div style={styles.skeleton} />}

        <img
          src={src}
          alt={revealed ? celebrityName : 'Who is this?'}
          onLoad={() => setLoaded(true)}
          onError={() => {
            if (!errored) {
              setErrored(true);
              setLoaded(false);
            }
          }}
          style={{
            ...styles.image,
            objectFit: isClearbit ? 'contain' : 'cover',
            padding: isClearbit ? '20px' : '0',
            filter: `blur(${blur}px)`,
            opacity: loaded ? 1 : 0,
            transition: 'filter 0.8s ease, opacity 0.4s ease',
          }}
        />

        {!revealed && (
          <div style={{
            ...styles.overlay,
            opacity: Math.max(0, (blur - 4) / 20) * 0.25,
          }} />
        )}
      </div>

      {revealed && (
        <div style={styles.nameBanner}>
          <span style={styles.nameText}>{celebrityName}</span>
        </div>
      )}

      <style>{`@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.5} }`}</style>
    </div>
  );
}

const styles = {
  wrapper: {
    position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center',
  },
  badge: {
    position: 'absolute', top: '12px', left: '12px', zIndex: 10,
    padding: '4px 10px', borderRadius: '20px',
    background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(8px)',
    fontSize: '11px', color: 'rgba(255,255,255,0.7)',
    border: '1px solid rgba(255,255,255,0.1)',
  },
  imageContainer: {
    position: 'relative', width: '280px', height: '280px',
    borderRadius: '20px', overflow: 'hidden',
    border: '2px solid rgba(99,102,241,0.3)',
    boxShadow: '0 0 40px rgba(99,102,241,0.15)',
  },
  skeleton: {
    position: 'absolute', inset: 0,
    background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
    animation: 'pulse 1.5s ease-in-out infinite',
  },
  image: {
    width: '100%', height: '100%', display: 'block',
  },
  overlay: {
    position: 'absolute', inset: 0,
    background: 'rgba(13,13,26,1)',
    pointerEvents: 'none', transition: 'opacity 0.8s ease',
  },
  nameBanner: {
    width: '100%', marginTop: '-1px',
    background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
    padding: '12px 20px', borderRadius: '0 0 18px 18px',
    textAlign: 'center',
  },
  nameText: {
    color: '#fff', fontSize: '18px', fontWeight: '800',
    fontFamily: "'Syne', sans-serif", letterSpacing: '0.5px',
  },
};